module.exports = __webpack_public_path__ + "img/cazana-rotate.b39729f9.svg";